/**
 * @file Generated by js-routes 2.3.6. Based on Rails 7.2.3 routes of AppVolition::Application.
 * @version 118fab87833175f81afbd2970634e599cdd277ca8cf42ed896223d393d1082f6
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {"trailing_slash":true},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                result.push(this.is_not_nullable(value) ||
                    true
                    ? encodeURIComponent(prefix) +
                        "=" +
                        encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : encodeURIComponent(prefix));
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /admin/campaign_votes_stats/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaign_votes_stats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/add_external_products_to_idea(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_add_external_products_to_idea_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"add_external_products_to_idea"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/classifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_classification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"classifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/classifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_classifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"classifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/exchange_rates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_exchange_rates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"exchange_rates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/external_categories_by_product_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_external_categories_by_product_ids_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"external_categories_by_product_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/external_products_by_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_external_products_by_ids_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"external_products_by_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/formulas/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_formula_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"formulas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/formulas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_formulas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"formulas"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/accept_with_agreement(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_accept_with_agreement_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"accept_with_agreement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/assign(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_assign_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/close(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_close_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/close_out(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_close_out_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"close_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/comments/:id(.:format)
 * @param {any} idea_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_comment_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/comments(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_comments_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/email(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_email_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/ingredient_tags(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_ingredient_tags_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"ingredient_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/product_brief(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_product_brief_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"product_brief"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/reassess(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_reassess_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"reassess"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/remove_similar_product(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_remove_similar_product_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"remove_similar_product"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/request_address(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_request_address_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"request_address"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/request_agreement(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_request_agreement_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"request_agreement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/request_video(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_request_video_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"request_video"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/sign_agreement(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_sign_agreement_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"sign_agreement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/similar_ideas(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_similar_ideas_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"similar_ideas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/similar_product_ids_by_tags(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_similar_product_ids_by_tags_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"similar_product_ids_by_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/solving_problem_tags(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_solving_problem_tags_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"solving_problem_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/texture_tags(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_texture_tags_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"texture_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/upload_agreement(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_upload_agreement_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"upload_agreement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:idea_id/upload_files(.:format)
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_idea_upload_files_path = /*#__PURE__*/ __jsr.r({"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"upload_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ideas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ingredient_tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ingredient_tags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ingredient_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/innovators/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_innovator_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"innovators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/innovators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_innovators_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"innovators"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/pin_external_product_to_idea(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_pin_external_product_to_idea_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pin_external_product_to_idea"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_briefs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_product_brief_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_briefs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_briefs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_product_briefs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_briefs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/remove_external_product_from_idea(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_remove_external_product_from_idea_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"remove_external_product_from_idea"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/solving_problem_tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_solving_problem_tags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"solving_problem_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/texture_tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_texture_tags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"texture_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/unpin_external_product_from_idea(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_unpin_external_product_from_idea_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"unpin_external_product_from_idea"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_base_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"api"]]);

/**
 * Generates rails route to
 * /best_sellers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const best_sellers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"best_sellers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /blog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /blog/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blog/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_post_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/comments(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_comments_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /the-lab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"the-lab"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /campaigns/live(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_live_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"live"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/skin-rhythm-balancing-clearing-serum(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_skin_rhythm_balancing_clearing_serum_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"skin-rhythm-balancing-clearing-serum"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categories_admin_ideas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ckeditor
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ckeditor_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"ckeditor"]]);

/**
 * Generates rails route to
 * /ckeditor/attachment_files/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ckeditor_attachment_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"ckeditor"]],[7,"/"]],[2,[6,"attachment_files"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ckeditor/attachment_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ckeditor_attachment_files_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"ckeditor"]],[7,"/"]],[2,[6,"attachment_files"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ckeditor/pictures/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ckeditor_picture_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"ckeditor"]],[7,"/"]],[2,[6,"pictures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ckeditor/pictures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ckeditor_pictures_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"ckeditor"]],[7,"/"]],[2,[6,"pictures"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cms_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cms_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cms_pages"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /consent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consent_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"consent"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_admin_ideas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notifications/destroy_all(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_all_user_notifications_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"destroy_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /phrasing/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_phrasing_phrases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"phrasing"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/downvote(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downvote_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"downvote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/formulas/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_formula_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"formulas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_idea_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/innovators/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_innovator_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"innovators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_briefs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_product_brief_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_briefs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/spree_oauth/applications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_oauth_application_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"spree_oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /phrasing/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_phrasing_phrase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"phrasing"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_processor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_processor"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /phrasing/help(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_phrasing_phrases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"phrasing"],[2,[7,"/"],[2,[6,"help"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /phrasing/import_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_export_phrasing_phrases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"phrasing"],[2,[7,"/"],[2,[6,"import_export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /innovator_highlights(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const innovator_highlights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"innovator_highlights"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /instagram/posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagram_posts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/labs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labs_admin_ideas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[6,"labs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /loyalty_program/facebook_like(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loyalty_program_facebook_like_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"facebook_like"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /loyalty_program/instagram_follow(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loyalty_program_instagram_follow_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"instagram_follow"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /loyalty_program/join_the_lounge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loyalty_program_join_the_lounge_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"join_the_lounge"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /loyalty_program/reactivate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loyalty_program_reactivate_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"reactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /loyalty_program/twitter_follow(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loyalty_program_twitter_follow_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"twitter_follow"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /marketing/bonsai(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketing_bonsai_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"bonsai"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /marketing/facebook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketing_facebook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"facebook"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /marketing/google(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketing_google_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"google"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /marketing/google_product_reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketing_google_product_reviews_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"google_product_reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notifications/:id/move(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_user_notification_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/spree_oauth/authorize/native(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const native_oauth_authorization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"spree_oauth"],[2,[7,"/"],[2,[6,"authorize"],[2,[7,"/"],[2,[6,"native"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_category_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/formulas/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_formula_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"formulas"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_idea_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/innovators/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_innovator_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"innovators"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_briefs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_product_brief_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_briefs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/spree_oauth/applications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_oauth_application_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"spree_oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_confirmation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/spree_oauth/applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_application_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"spree_oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/spree_oauth/applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_applications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"spree_oauth"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/spree_oauth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"spree_oauth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/spree_oauth/authorized_applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorized_application_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"spree_oauth"],[2,[7,"/"],[2,[6,"authorized_applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/spree_oauth/authorized_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorized_applications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"spree_oauth"],[2,[7,"/"],[2,[6,"authorized_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/spree_oauth/introspect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_introspect_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"spree_oauth"],[2,[7,"/"],[2,[6,"introspect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/spree_oauth/revoke(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_revoke_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"spree_oauth"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/spree_oauth/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"spree_oauth"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/spree_oauth/token/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_token_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"spree_oauth"],[2,[7,"/"],[2,[6,"token"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notifications/open_all(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const open_all_user_notifications_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"open_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notifications/:id/open(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const open_user_notification_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"open"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /phrasing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phrasing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"phrasing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /phrasing/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phrasing_phrase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"phrasing"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /phrasing_phrase_versions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phrasing_phrase_version_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"phrasing_phrase_versions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /phrasing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const phrasing_phrases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"phrasing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /press(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const press_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"press"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /press/NYO_article(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const press_NYO_article_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"press"],[2,[7,"/"],[2,[6,"NYO_article"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /press/SFC_article(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const press_SFC_article_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"press"],[2,[7,"/"],[2,[6,"SFC_article"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/promotions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const promotions_admin_ideas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[6,"promotions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pyxis_root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /quizzes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quiz_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /quizzes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quizzes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/subscriptions/:id/reactivate(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reactivate_user_subscription_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /regimen_finder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regimen_finder_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regimen_finder"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /regimen_finder/all_products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regimen_finder_all_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regimen_finder"],[2,[7,"/"],[2,[6,"all_products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /regimen_finder/bought_product_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regimen_finder_bought_product_ids_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regimen_finder"],[2,[7,"/"],[2,[6,"bought_product_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /regimen_finder/products_taggings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regimen_finder_products_taggings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regimen_finder"],[2,[7,"/"],[2,[6,"products_taggings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /regimen_finder/send_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regimen_finder_send_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regimen_finder"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /regimen_finder/skincare_products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regimen_finder_skincare_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regimen_finder"],[2,[7,"/"],[2,[6,"skincare_products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reviewer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reviewer"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/reviewers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewers_admin_ideas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[6,"reviewers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /search/track_result(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_track_result_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"track_result"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/quiz_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shop_admin_reports_quiz_update_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"quiz_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/orders/populate_multiple(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shop_orders_populate_multiple_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"populate_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/orders/quadpay_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shop_orders_quadpay_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"quadpay_callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shops/address(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shops_address_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shops"],[2,[7,"/"],[2,[6,"address"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shops/index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shops_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shops"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiq_web_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"sidekiq"]]);

/**
 * Generates rails route to
 * /shop
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"shop"]]);

/**
 * Generates rails route to
 * /shop/admin/users/:id/activate_loyalty_program(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_activate_loyalty_program_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate_loyalty_program"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/return_authorizations/:id/add(.:format)
 * @param {any} checkout_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_add_api_v1_checkout_return_authorization_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/return_authorizations/:id/add(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_add_api_v1_order_return_authorization_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/shipments/:id/add(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_add_api_v1_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/return_authorizations/:id/add(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_add_api_v2_platform_return_authorization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/add_gift_card(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_add_gift_card_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"add_gift_card"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipments/:id/add_item(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_add_item_api_v2_platform_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/cart/add_item(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_add_item_api_v2_storefront_cart_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"add_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/wishlists/:id/add_item(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_add_item_api_v2_storefront_wishlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/wishlists/:id/add_items(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_add_items_api_v2_storefront_wishlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/users/:id/add_points(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_add_points_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_points"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/checkout/add_store_credit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_add_store_credit_api_v2_storefront_checkout_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"add_store_credit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/users/:id/addresses(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_addresses_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /shop/admin/regimen_finder_products/:id/update_tags(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_admin_regimen_finder_product_update_tags_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"regimen_finder_products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/regimen_finder_products/:id/update_weights(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_admin_regimen_finder_product_update_weights_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"regimen_finder_products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_weights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/articles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_article_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/articles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_articles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/banners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_banner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/banners/:banner_id/desktop_video(.:format)
 * @param {any} banner_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_banner_desktop_video_path = /*#__PURE__*/ __jsr.r({"banner_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banners"],[2,[7,"/"],[2,[3,"banner_id"],[2,[7,"/"],[2,[6,"desktop_video"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/banners/:banner_id/mobile_video(.:format)
 * @param {any} banner_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_banner_mobile_video_path = /*#__PURE__*/ __jsr.r({"banner_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banners"],[2,[7,"/"],[2,[3,"banner_id"],[2,[7,"/"],[2,[6,"mobile_video"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/banners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_banners_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blacklisted_addresses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_blacklisted_address_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blacklisted_addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blacklisted_address_conserve(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_blacklisted_address_conserve_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blacklisted_address_conserve"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blacklisted_addresses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_blacklisted_addresses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blacklisted_addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blacklisted_domains/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_blacklisted_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blacklisted_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blacklisted_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_blacklisted_domains_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blacklisted_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blacklisted_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_blacklisted_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blacklisted_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blacklisted_email_conserve(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_blacklisted_email_conserve_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blacklisted_email_conserve"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blacklisted_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_blacklisted_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blacklisted_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blog/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_blog_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blog/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_blog_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blog/posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_blog_post_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blog/posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_blog_posts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/bookkeeping_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_bookkeeping_document_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bookkeeping_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/bookkeeping_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_bookkeeping_documents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bookkeeping_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/campaign_comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_campaign_comments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaign_comments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/campaigns/:campaign_id/complete(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_campaign_complete_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/campaigns/:campaign_id/reimburse_preorders(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_campaign_reimburse_preorders_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"reimburse_preorders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/campaigns/:campaign_id/unlock_pending_point_movements(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_campaign_unlock_pending_point_movements_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"unlock_pending_point_movements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/campaigns/:campaign_id/variants/:id(.:format)
 * @param {any} campaign_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_campaign_variant_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/campaigns/:campaign_id/variants(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_campaign_variants_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"variants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/campaigns/:campaign_id/votes/:id(.:format)
 * @param {any} campaign_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_campaign_vote_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"votes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/campaigns/:campaign_id/votes(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_campaign_votes_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"votes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/cms/pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_cms_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cms"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/cms/pages/:page_id/blocks/:id(.:format)
 * @param {any} page_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_cms_page_block_path = /*#__PURE__*/ __jsr.r({"page_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cms"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/cms/pages/:page_id/blocks(.:format)
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_cms_page_blocks_path = /*#__PURE__*/ __jsr.r({"page_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cms"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_id"],[2,[7,"/"],[2,[6,"blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/cms_pages/:cms_page_id/cms_sections/:id(.:format)
 * @param {any} cms_page_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_cms_page_cms_section_path = /*#__PURE__*/ __jsr.r({"cms_page_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cms_pages"],[2,[7,"/"],[2,[3,"cms_page_id"],[2,[7,"/"],[2,[6,"cms_sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/cms_pages/:cms_page_id/cms_sections(.:format)
 * @param {any} cms_page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_cms_page_cms_sections_path = /*#__PURE__*/ __jsr.r({"cms_page_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cms_pages"],[2,[7,"/"],[2,[3,"cms_page_id"],[2,[7,"/"],[2,[6,"cms_sections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/cms/pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_cms_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cms"],[2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_comments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/countries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_countries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"countries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/countries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_country_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"countries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/countries/:country_id/states/:id(.:format)
 * @param {any} country_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_country_state_path = /*#__PURE__*/ __jsr.r({"country_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"countries"],[2,[7,"/"],[2,[3,"country_id"],[2,[7,"/"],[2,[6,"states"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/countries/:country_id/states(.:format)
 * @param {any} country_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_country_states_path = /*#__PURE__*/ __jsr.r({"country_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"countries"],[2,[7,"/"],[2,[3,"country_id"],[2,[7,"/"],[2,[6,"states"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/customer_returns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_customer_returns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_returns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/data_feeds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_data_feed_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"data_feeds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/data_feeds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_data_feeds_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"data_feeds"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/campaign_comment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_delete_campaign_comment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaign_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/desktop_top_banners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_desktop_top_banner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"desktop_top_banners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/desktop_top_banners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_desktop_top_banners_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"desktop_top_banners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/editable_pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_editable_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"editable_pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/editable_pages/:editable_page_id/editable_page_images/:id(.:format)
 * @param {any} editable_page_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_editable_page_editable_page_image_path = /*#__PURE__*/ __jsr.r({"editable_page_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"editable_pages"],[2,[7,"/"],[2,[3,"editable_page_id"],[2,[7,"/"],[2,[6,"editable_page_images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/editable_pages/:editable_page_id/editable_page_images(.:format)
 * @param {any} editable_page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_editable_page_editable_page_images_path = /*#__PURE__*/ __jsr.r({"editable_page_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"editable_pages"],[2,[7,"/"],[2,[3,"editable_page_id"],[2,[7,"/"],[2,[6,"editable_page_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/editable_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_editable_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"editable_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/external_comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_external_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"external_comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/external_comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_external_comments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"external_comments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/facebook_comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_facebook_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"facebook_comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/facebook_comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_facebook_comments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"facebook_comments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/forbidden(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_forbidden_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"forbidden"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/free_samples/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_free_sample_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"free_samples"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/free_samples(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_free_samples_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"free_samples"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/gift_cards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_gift_card_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"gift_cards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/gift_cards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_gift_cards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"gift_cards"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/homepage_innovators/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_homepage_innovator_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"homepage_innovators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/homepage_innovators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_homepage_innovators_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"homepage_innovators"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/ingredients/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_ingredient_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ingredients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/ingredients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_ingredients_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ingredients"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/innovator_highlights/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_innovator_highlight_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"innovator_highlights"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/innovator_highlights(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_innovator_highlights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"innovator_highlights"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/double_points_products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_loyalty_program_double_points_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"double_points_products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/double_points_products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_loyalty_program_double_points_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"double_points_products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/point_actions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_loyalty_program_point_action_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"point_actions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/point_actions/:point_action_id/point_movements(.:format)
 * @param {any} point_action_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_loyalty_program_point_action_point_movements_path = /*#__PURE__*/ __jsr.r({"point_action_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"point_actions"],[2,[7,"/"],[2,[3,"point_action_id"],[2,[7,"/"],[2,[6,"point_movements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/point_actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_loyalty_program_point_actions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"point_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/redeem_point_actions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_loyalty_program_redeem_point_action_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"redeem_point_actions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/redeem_point_actions/:redeem_point_action_id/point_movements(.:format)
 * @param {any} redeem_point_action_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_loyalty_program_redeem_point_action_point_movements_path = /*#__PURE__*/ __jsr.r({"redeem_point_action_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"redeem_point_actions"],[2,[7,"/"],[2,[3,"redeem_point_action_id"],[2,[7,"/"],[2,[6,"point_movements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/redeem_point_actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_loyalty_program_redeem_point_actions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"redeem_point_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/tiers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_loyalty_program_tier_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"tiers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/tiers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_loyalty_program_tiers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"tiers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/menus/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_menu_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/menus/:menu_id/menu_items/:id(.:format)
 * @param {any} menu_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_menu_menu_item_path = /*#__PURE__*/ __jsr.r({"menu_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"menu_id"],[2,[7,"/"],[2,[6,"menu_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/menus/:menu_id/menu_items(.:format)
 * @param {any} menu_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_menu_menu_items_path = /*#__PURE__*/ __jsr.r({"menu_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"menu_id"],[2,[7,"/"],[2,[6,"menu_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/menus(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_menus_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"menus"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/mobile_top_banners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_mobile_top_banner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mobile_top_banners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/mobile_top_banners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_mobile_top_banners_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mobile_top_banners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/oauth_applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_oauth_application_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth_applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/oauth_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_oauth_applications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/option_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_option_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/option_types/:option_type_id/option_values/:id(.:format)
 * @param {any} option_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_option_type_option_value_path = /*#__PURE__*/ __jsr.r({"option_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[3,"option_type_id"],[2,[7,"/"],[2,[6,"option_values"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/option_types/:option_type_id/option_values(.:format)
 * @param {any} option_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_option_type_option_values_path = /*#__PURE__*/ __jsr.r({"option_type_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[3,"option_type_id"],[2,[7,"/"],[2,[6,"option_values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/option_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_option_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"option_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/option_values/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_option_value_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"option_values"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/adjustments/:id(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_adjustment_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/adjustments/:id/refund(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_adjustment_refund_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/adjustments(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_adjustments_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"adjustments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/bookkeeping_documents(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_bookkeeping_documents_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"bookkeeping_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/customer(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_customer_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"customer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/customer_returns/:id(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_customer_return_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"customer_returns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/customer_returns(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_customer_returns_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"customer_returns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/payments/:id(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_payment_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/payments/:payment_id/log_entries(.:format)
 * @param {any} order_id
 * @param {any} payment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_payment_log_entries_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"payment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"payment_id"],[2,[7,"/"],[2,[6,"log_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/payments/:payment_id/log_entries/:id(.:format)
 * @param {any} order_id
 * @param {any} payment_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_payment_log_entry_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"payment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"payment_id"],[2,[7,"/"],[2,[6,"log_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/payments/:payment_id/refunds/:id(.:format)
 * @param {any} order_id
 * @param {any} payment_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_payment_refund_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"payment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"payment_id"],[2,[7,"/"],[2,[6,"refunds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/payments/:payment_id/refunds(.:format)
 * @param {any} order_id
 * @param {any} payment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_payment_refunds_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"payment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"payment_id"],[2,[7,"/"],[2,[6,"refunds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/payments(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_payments_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/point_movements(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_point_movements_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"point_movements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/reimbursements/:id(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_reimbursement_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"reimbursements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/reimbursements(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_reimbursements_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"reimbursements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/return_authorizations/:id(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_return_authorization_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/return_authorizations(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_return_authorizations_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/state_changes(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_order_state_changes_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"state_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/payment_methods/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_payment_method_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/payment_methods(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_payment_methods_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_methods"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/press_banners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_press_banner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"press_banners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/press_banners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_press_banners_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"press_banners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/print_invoice_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_print_invoice_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"print_invoice_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/digitals/:id(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_product_digital_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"digitals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/digitals(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_product_digitals_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"digitals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/images/:id(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_product_image_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/images(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_product_images_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/ingredients(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_product_ingredients_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"ingredients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/ingredients/update_positions(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_product_ingredients_update_positions_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"ingredients"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/prices(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_product_prices_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"prices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/product_properties(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_product_product_properties_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"product_properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/product_properties/:id(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_product_product_property_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"product_properties"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/product_properties/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_product_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_properties"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/relations/:id(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_product_relation_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"relations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/relations(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_product_relations_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"relations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/variants/:id(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_product_variant_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/variants(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_product_variants_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/variants_including_master/:id(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_product_variants_including_master_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variants_including_master"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_promotion_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotion_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_promotion_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotion_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotion_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_promotion_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotion_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotions/:promotion_id/promotion_actions/:id(.:format)
 * @param {any} promotion_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_promotion_promotion_action_path = /*#__PURE__*/ __jsr.r({"promotion_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[3,"promotion_id"],[2,[7,"/"],[2,[6,"promotion_actions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotions/:promotion_id/promotion_actions(.:format)
 * @param {any} promotion_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_promotion_promotion_actions_path = /*#__PURE__*/ __jsr.r({"promotion_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[3,"promotion_id"],[2,[7,"/"],[2,[6,"promotion_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotions/:promotion_id/promotion_rules/:id(.:format)
 * @param {any} promotion_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_promotion_promotion_rule_path = /*#__PURE__*/ __jsr.r({"promotion_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[3,"promotion_id"],[2,[7,"/"],[2,[6,"promotion_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotions/:promotion_id/promotion_rules(.:format)
 * @param {any} promotion_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_promotion_promotion_rules_path = /*#__PURE__*/ __jsr.r({"promotion_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[3,"promotion_id"],[2,[7,"/"],[2,[6,"promotion_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_promotions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/properties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_properties_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/properties/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/prototypes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_prototype_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"prototypes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/prototypes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_prototypes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"prototypes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/quad_pay_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_quad_pay_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"quad_pay_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_question_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_questions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"questions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/refund_reasons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_refund_reason_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"refund_reasons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/refund_reasons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_refund_reasons_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"refund_reasons"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/regimen_finder_products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_regimen_finder_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"regimen_finder_products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/regimen_finder_products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_regimen_finder_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"regimen_finder_products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/regimen_finder_results(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_regimen_finder_results_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"regimen_finder_results"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reimbursement_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_reimbursement_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reimbursement_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reimbursement_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_reimbursement_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reimbursement_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/relation_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_relation_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"relation_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/relation_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_relation_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"relation_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/return_authorization_reasons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_return_authorization_reason_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"return_authorization_reasons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/return_authorization_reasons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_return_authorization_reasons_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"return_authorization_reasons"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/return_authorizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_return_authorizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"return_authorizations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/return_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_return_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"return_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reviews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_review_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reviews/:review_id/reply(.:format)
 * @param {any} review_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_review_reply_path = /*#__PURE__*/ __jsr.r({"review_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"review_id"],[2,[7,"/"],[2,[6,"reply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_reviews_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_role_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/roles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_roles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /shop/admin/search/ingredients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_search_ingredients_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"ingredients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/search_queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_search_queries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"search_queries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/search_results(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_search_results_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"search_results"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/searchable_pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_searchable_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"searchable_pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/searchable_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_searchable_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"searchable_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/shipping_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_shipping_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"shipping_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/shipping_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_shipping_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"shipping_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/shipping_methods/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_shipping_method_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"shipping_methods"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/shipping_methods(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_shipping_methods_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"shipping_methods"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/shops/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_shop_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"shops"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/shop_dropdown_image(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_shop_dropdown_image_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"shop_dropdown_image"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/shops(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_shops_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"shops"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/states/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_state_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"states"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/states(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_states_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"states"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stock_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_stock_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stock_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stock_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_stock_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stock_items"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stock_locations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_stock_location_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stock_locations/:stock_location_id/stock_movements/:id(.:format)
 * @param {any} stock_location_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_stock_location_stock_movement_path = /*#__PURE__*/ __jsr.r({"stock_location_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"stock_location_id"],[2,[7,"/"],[2,[6,"stock_movements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stock_locations/:stock_location_id/stock_movements(.:format)
 * @param {any} stock_location_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_stock_location_stock_movements_path = /*#__PURE__*/ __jsr.r({"stock_location_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"stock_location_id"],[2,[7,"/"],[2,[6,"stock_movements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stock_locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_stock_locations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stock_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stock_transfers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_stock_transfer_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stock_transfers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stock_transfers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_stock_transfers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stock_transfers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stores/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_store_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stores"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/store_credit_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_store_credit_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"store_credit_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/store_credit_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_store_credit_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"store_credit_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stores(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_stores_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stores"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/subscriptions/:subscription_id/create_order(.:format)
 * @param {any} subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_subscription_create_order_path = /*#__PURE__*/ __jsr.r({"subscription_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"subscription_id"],[2,[7,"/"],[2,[6,"create_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/subscriptions/:subscription_id/reactivate(.:format)
 * @param {any} subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_subscription_reactivate_path = /*#__PURE__*/ __jsr.r({"subscription_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"subscription_id"],[2,[7,"/"],[2,[6,"reactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/subscriptions/:subscription_id/send_reminder(.:format)
 * @param {any} subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_subscription_send_reminder_path = /*#__PURE__*/ __jsr.r({"subscription_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"subscription_id"],[2,[7,"/"],[2,[6,"send_reminder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/subscriptions/:subscription_id/subscription_renewals(.:format)
 * @param {any} subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_subscription_subscription_renewals_path = /*#__PURE__*/ __jsr.r({"subscription_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"subscription_id"],[2,[7,"/"],[2,[6,"subscription_renewals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/suspicious_votes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_suspicious_votes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"suspicious_votes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/tax_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_tax_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tax_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/tax_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_tax_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tax_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/tax_rates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_tax_rate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tax_rates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/tax_rates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_tax_rates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tax_rates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxjar_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_taxjar_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxjar_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_taxon_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxonomies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_taxonomies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxonomies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxonomies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_taxonomy_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxonomies/:taxonomy_id/taxons/:id(.:format)
 * @param {any} taxonomy_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_taxonomy_taxon_path = /*#__PURE__*/ __jsr.r({"taxonomy_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"taxonomy_id"],[2,[7,"/"],[2,[6,"taxons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxonomies/:taxonomy_id/taxons(.:format)
 * @param {any} taxonomy_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_taxonomy_taxons_path = /*#__PURE__*/ __jsr.r({"taxonomy_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"taxonomy_id"],[2,[7,"/"],[2,[6,"taxons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_taxons_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxons"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/users/:user_id/point_movements(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_user_point_movements_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"point_movements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/users/:user_id/store_credits/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_user_store_credit_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"store_credits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/users/:user_id/store_credits(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_user_store_credits_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"store_credits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/vanity_urls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_vanity_url_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vanity_urls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/vanity_urls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_vanity_urls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vanity_urls"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/waitlists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_waitlists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"waitlists"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/webhooks_subscribers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_webhooks_subscriber_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"webhooks_subscribers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/webhooks_subscribers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_webhooks_subscribers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"webhooks_subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/zones/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_zone_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/zones(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_admin_zones_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:id/advance(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_advance_api_v1_checkout_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"advance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/orders/:id/advance(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_advance_api_v2_platform_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"advance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/checkout/advance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_advance_api_v2_storefront_checkout_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"advance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/products/:product_id/relations/:id(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_product_relation_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"relations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/products/:product_id/relations(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_product_relations_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"relations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:id/email_update(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"email_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_checkout_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/addresses/:id(.:format)
 * @param {any} checkout_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_checkout_address_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/line_items/:id(.:format)
 * @param {any} checkout_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_checkout_line_item_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"line_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/line_items(.:format)
 * @param {any} checkout_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_checkout_line_items_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"line_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/payments/:id(.:format)
 * @param {any} checkout_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_checkout_payment_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/payments(.:format)
 * @param {any} checkout_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_checkout_payments_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/return_authorizations/:id(.:format)
 * @param {any} checkout_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_checkout_return_authorization_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/return_authorizations(.:format)
 * @param {any} checkout_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_checkout_return_authorizations_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/classifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_classifications_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"classifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/countries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_countries_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"countries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/countries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_country_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"countries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/countries/:country_id/states/:id(.:format)
 * @param {any} country_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_country_state_path = /*#__PURE__*/ __jsr.r({"country_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"countries"],[2,[7,"/"],[2,[3,"country_id"],[2,[7,"/"],[2,[6,"states"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/countries/:country_id/states(.:format)
 * @param {any} country_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_country_states_path = /*#__PURE__*/ __jsr.r({"country_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"countries"],[2,[7,"/"],[2,[3,"country_id"],[2,[7,"/"],[2,[6,"states"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/current(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_current_order_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"current"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/customer_returns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_customer_returns_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"customer_returns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/ingredients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_ingredients_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ingredients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/inventory_units/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_inventory_unit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"inventory_units"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/mine(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_my_orders_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"mine"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/option_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_option_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/option_types/:option_type_id/option_values/:id(.:format)
 * @param {any} option_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_option_type_option_value_path = /*#__PURE__*/ __jsr.r({"option_type_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[3,"option_type_id"],[2,[7,"/"],[2,[6,"option_values"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/option_types/:option_type_id/option_values(.:format)
 * @param {any} option_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_option_type_option_values_path = /*#__PURE__*/ __jsr.r({"option_type_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[3,"option_type_id"],[2,[7,"/"],[2,[6,"option_values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/option_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_option_types_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"option_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/option_values/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_option_value_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"option_values"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/option_values(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_option_values_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"option_values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/addresses/:id(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_order_address_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/line_items/:id(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_order_line_item_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"line_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/line_items(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_order_line_items_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"line_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/payments/:id(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_order_payment_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/payments(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_order_payments_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/return_authorizations/:id(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_order_return_authorization_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/return_authorizations(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_order_return_authorizations_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_orders_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/products/:product_id/images/:id(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_product_image_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/products/:product_id/images(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_product_images_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/products/:product_id/product_properties(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_product_product_properties_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"product_properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/products/:product_id/product_properties/:id(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_product_product_property_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"product_properties"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/products/:product_id/variants/:id(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_product_variant_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/products/:product_id/variants(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_product_variants_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_products_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/promotions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_promotion_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/properties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_properties_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/properties/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/reimbursements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_reimbursements_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reimbursements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/shipments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/shipments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_shipments_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"shipments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/states/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_state_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"states"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/states(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_states_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"states"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stock_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_stock_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stock_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stock_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_stock_items_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stock_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stock_locations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_stock_location_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stock_locations/:stock_location_id/stock_items/:id(.:format)
 * @param {any} stock_location_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_stock_location_stock_item_path = /*#__PURE__*/ __jsr.r({"stock_location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"stock_location_id"],[2,[7,"/"],[2,[6,"stock_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stock_locations/:stock_location_id/stock_items(.:format)
 * @param {any} stock_location_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_stock_location_stock_items_path = /*#__PURE__*/ __jsr.r({"stock_location_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"stock_location_id"],[2,[7,"/"],[2,[6,"stock_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stock_locations/:stock_location_id/stock_movements/:id(.:format)
 * @param {any} stock_location_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_stock_location_stock_movement_path = /*#__PURE__*/ __jsr.r({"stock_location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"stock_location_id"],[2,[7,"/"],[2,[6,"stock_movements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stock_locations/:stock_location_id/stock_movements(.:format)
 * @param {any} stock_location_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_stock_location_stock_movements_path = /*#__PURE__*/ __jsr.r({"stock_location_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"stock_location_id"],[2,[7,"/"],[2,[6,"stock_movements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stock_locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_stock_locations_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stock_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stores/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_store_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stores"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stores(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_stores_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stores"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/taxons/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_taxon_products_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"taxons"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/taxonomies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_taxonomies_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"taxonomies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/taxonomies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_taxonomy_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/taxonomies/:taxonomy_id/taxons/:id(.:format)
 * @param {any} taxonomy_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_taxonomy_taxon_path = /*#__PURE__*/ __jsr.r({"taxonomy_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"taxonomy_id"],[2,[7,"/"],[2,[6,"taxons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/taxonomies/:taxonomy_id/taxons(.:format)
 * @param {any} taxonomy_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_taxonomy_taxons_path = /*#__PURE__*/ __jsr.r({"taxonomy_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"taxonomy_id"],[2,[7,"/"],[2,[6,"taxons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/taxons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_taxons_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"taxons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/users/:user_id/credit_cards(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_user_credit_cards_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"credit_cards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_users_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/variants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_variant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/variants/:variant_id/images/:id(.:format)
 * @param {any} variant_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_variant_image_path = /*#__PURE__*/ __jsr.r({"variant_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"variant_id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/variants/:variant_id/images(.:format)
 * @param {any} variant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_variant_images_path = /*#__PURE__*/ __jsr.r({"variant_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"variant_id"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/variants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_variants_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"variants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/zones/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_zone_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/zones(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v1_zones_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"zones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/data_feeds/google/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_data_feeds_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"data_feeds"],[2,[7,"/"],[2,[6,"google"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/addresses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_address_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/addresses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_addresses_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/adjustments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_adjustment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/adjustments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_adjustments_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"adjustments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/classifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_classification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"classifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/classifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_classifications_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"classifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/cms_pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_cms_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"cms_pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/cms_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_cms_pages_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"cms_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/cms_sections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_cms_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"cms_sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/cms_sections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_cms_sections_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"cms_sections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/countries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_countries_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"countries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/countries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_country_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"countries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/credit_cards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_credit_card_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"credit_cards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/credit_cards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_credit_cards_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"credit_cards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/customer_returns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_customer_return_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"customer_returns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/customer_returns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_customer_returns_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"customer_returns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/data_feeds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_data_feed_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"data_feeds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/data_feeds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_data_feeds_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"data_feeds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/digitals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_digital_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"digitals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/digital_links/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_digital_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"digital_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/digital_links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_digital_links_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"digital_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/digitals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_digitals_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"digitals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/images/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_images_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/inventory_units/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_inventory_unit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"inventory_units"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/inventory_units(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_inventory_units_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"inventory_units"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/line_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_line_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"line_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/line_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_line_items_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"line_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/menus/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_menu_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/menu_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_menu_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"menu_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/menu_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_menu_items_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"menu_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/menus(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_menus_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"menus"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/option_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_option_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/option_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_option_types_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"option_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/option_values/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_option_value_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"option_values"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/option_values(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_option_values_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"option_values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_orders_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/payments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_payment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/payment_methods/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_payment_method_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/payment_methods(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_payment_methods_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"payment_methods"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_payments_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/product_properties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_product_properties_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"product_properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/product_properties/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_product_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"product_properties"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_products_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/promotions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_promotion_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/promotion_actions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_promotion_action_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"promotion_actions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/promotion_actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_promotion_actions_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"promotion_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/promotion_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_promotion_categories_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"promotion_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/promotion_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_promotion_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"promotion_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/promotion_rules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_promotion_rule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"promotion_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/promotion_rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_promotion_rules_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"promotion_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/promotions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_promotions_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"promotions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/properties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_properties_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/properties/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/reimbursements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_reimbursement_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"reimbursements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/reimbursements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_reimbursements_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"reimbursements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/return_authorizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_return_authorization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/return_authorizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_return_authorizations_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"return_authorizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_role_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/roles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_roles_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_shipments_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipping_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_shipping_categories_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipping_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipping_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_shipping_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipping_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipping_methods/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_shipping_method_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipping_methods"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipping_methods(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_shipping_methods_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipping_methods"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/states/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_state_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"states"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/states(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_states_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"states"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/stock_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_stock_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"stock_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/stock_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_stock_items_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"stock_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/stock_locations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_stock_location_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/stock_locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_stock_locations_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"stock_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/stock_movements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_stock_movement_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"stock_movements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/stock_movements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_stock_movements_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"stock_movements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/stores/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_store_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"stores"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/store_credits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_store_credit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"store_credits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/store_credit_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_store_credit_categories_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"store_credit_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/store_credit_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_store_credit_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"store_credit_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/store_credit_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_store_credit_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"store_credit_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/store_credit_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_store_credit_types_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"store_credit_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/store_credits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_store_credits_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"store_credits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/stores(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_stores_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"stores"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/tax_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_tax_categories_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"tax_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/tax_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_tax_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"tax_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/tax_rates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_tax_rate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"tax_rates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/tax_rates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_tax_rates_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"tax_rates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/taxons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_taxon_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"taxons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/taxonomies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_taxonomies_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"taxonomies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/taxonomies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_taxonomy_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/taxons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_taxons_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"taxons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_users_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/variants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_variant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/variants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_variants_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"variants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/webhooks/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_webhooks_events_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/webhooks/subscribers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_webhooks_subscriber_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/webhooks/subscribers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_webhooks_subscribers_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/wished_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_wished_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"wished_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/wished_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_wished_items_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"wished_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/wishlists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_wishlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/wishlists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_wishlists_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"wishlists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/zones/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_zone_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/zones(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_platform_zones_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"zones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_account_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/account/addresses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_account_address_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/account/addresses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_account_addresses_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/account/credit_cards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_account_credit_card_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"credit_cards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/account/credit_cards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_account_credit_cards_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"credit_cards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/account/orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_account_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/account/orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_account_orders_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/cart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_cart_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"cart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_checkout_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/cms_pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_cms_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"cms_pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/cms_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_cms_pages_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"cms_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/countries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_countries_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"countries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/countries/:iso(.:format)
 * @param {any} iso
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_country_path = /*#__PURE__*/ __jsr.r({"iso":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"countries"],[2,[7,"/"],[2,[3,"iso"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/store(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_current_store_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"store"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/digitals/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_digital_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"digitals"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/intents/handle_response(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_intents_handle_response_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"intents"],[2,[7,"/"],[2,[6,"handle_response"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/intents/payment_confirmation_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_intents_payment_confirmation_data_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"intents"],[2,[7,"/"],[2,[6,"payment_confirmation_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/menus/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_menu_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/menus(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_menus_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"menus"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/order_status/:number(.:format)
 * @param {any} number
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_order_status_path = /*#__PURE__*/ __jsr.r({"number":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"order_status"],[2,[7,"/"],[2,[3,"number"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/products/:id/variants(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_product_variants_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"variants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_products_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/stores/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_store_path = /*#__PURE__*/ __jsr.r({"code":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"stores"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/taxons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_taxon_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"taxons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/taxons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_taxons_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"taxons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/wishlists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_wishlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/wishlists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_api_v2_storefront_wishlists_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"wishlists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:id/apply_coupon_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_apply_coupon_code_api_v1_checkout_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply_coupon_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:id/apply_coupon_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_apply_coupon_code_api_v1_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply_coupon_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/orders/:id/apply_coupon_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_apply_coupon_code_api_v2_platform_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply_coupon_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/cart/apply_coupon_code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_apply_coupon_code_api_v2_storefront_cart_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"apply_coupon_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_approve_admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_approve_api_v1_checkout_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_approve_api_v1_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/orders/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_approve_api_v2_platform_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/cart/associate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_associate_api_v2_storefront_cart_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/payments/:id/authorize(.:format)
 * @param {any} checkout_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_authorize_api_v1_checkout_payment_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/payments/:id/authorize(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_authorize_api_v1_order_payment_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/prototypes/available(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_available_admin_prototypes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"prototypes"],[2,[7,"/"],[2,[6,"available"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cancel_admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/return_authorizations/:id/cancel(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cancel_admin_order_return_authorization_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cancel_api_v1_checkout_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/return_authorizations/:id/cancel(.:format)
 * @param {any} checkout_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cancel_api_v1_checkout_return_authorization_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cancel_api_v1_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/return_authorizations/:id/cancel(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cancel_api_v1_order_return_authorization_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/orders/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cancel_api_v2_platform_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/return_authorizations/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cancel_api_v2_platform_return_authorization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipments/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cancel_api_v2_platform_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/paypal/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cancel_paypal_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/payments/:id/capture(.:format)
 * @param {any} checkout_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_capture_api_v1_checkout_payment_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"capture"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/payments/:id/capture(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_capture_api_v1_order_payment_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"capture"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/cart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cart_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"cart"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:id/cart(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cart_admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/cart/remove_coupon_code/:coupon_code(.:format)
 * @param {any} coupon_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cart_remove_coupon_code_api_v2_storefront_cart_path = /*#__PURE__*/ __jsr.r({"coupon_code":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"remove_coupon_code"],[2,[7,"/"],[2,[3,"coupon_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/cart/remove_coupon_code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cart_remove_coupon_code_without_code_api_v2_storefront_cart_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"remove_coupon_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/cart/remove_line_item/:line_item_id(.:format)
 * @param {any} line_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cart_remove_line_item_api_v2_storefront_cart_path = /*#__PURE__*/ __jsr.r({"line_item_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"remove_line_item"],[2,[7,"/"],[2,[3,"line_item_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/cart/change_currency(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_change_currency_api_v2_storefront_cart_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"change_currency"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:id/channel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_channel_admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/checkout_now/apply_store_credit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_checkout_now_apply_store_credit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"checkout_now"],[2,[7,"/"],[2,[6,"apply_store_credit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/checkout_now/order(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_checkout_now_order_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"checkout_now"],[2,[7,"/"],[2,[6,"order"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/checkout_now/remove_store_credit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_checkout_now_remove_store_credit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"checkout_now"],[2,[7,"/"],[2,[6,"remove_store_credit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/checkout_now/update_payment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_checkout_now_update_payment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"checkout_now"],[2,[7,"/"],[2,[6,"update_payment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/checkout_now/update_shipping_address(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_checkout_now_update_shipping_address_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"checkout_now"],[2,[7,"/"],[2,[6,"update_shipping_address"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/checkout_now/update_shipping_method(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_checkout_now_update_shipping_method_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"checkout_now"],[2,[7,"/"],[2,[6,"update_shipping_method"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_clone_admin_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotions/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_clone_admin_promotion_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:id/close_adjustments(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_close_adjustments_admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close_adjustments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/cohort(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cohort_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"cohort"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/cohort_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_cohort_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"cohort_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/orders/:id/complete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_complete_api_v2_platform_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/checkout/complete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_complete_api_v2_storefront_checkout_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/paypal/confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_confirm_paypal_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/checkout/create_payment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_create_payment_api_v2_storefront_checkout_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"create_payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/payments/:id/credit(.:format)
 * @param {any} checkout_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_credit_api_v1_checkout_payment_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"credit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/payments/:id/credit(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_credit_api_v1_order_payment_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"credit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/users/:id/deactivate_loyalty_program(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_deactivate_loyalty_program_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate_loyalty_program"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/wishlists/default(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_default_api_v2_storefront_wishlists_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[6,"default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/articles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_article_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/banners/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_banner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blacklisted_addresses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_blacklisted_address_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blacklisted_addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blacklisted_emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_blacklisted_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blacklisted_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blog/categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_blog_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blog/posts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_blog_post_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/campaigns/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/campaigns/:campaign_id/variants/:id/edit(.:format)
 * @param {any} campaign_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_campaign_variant_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/cms/pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_cms_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cms"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/cms/pages/:page_id/blocks/:id/edit(.:format)
 * @param {any} page_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_cms_page_block_path = /*#__PURE__*/ __jsr.r({"page_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cms"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/cms_pages/:cms_page_id/cms_sections/:id/edit(.:format)
 * @param {any} cms_page_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_cms_page_cms_section_path = /*#__PURE__*/ __jsr.r({"cms_page_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cms_pages"],[2,[7,"/"],[2,[3,"cms_page_id"],[2,[7,"/"],[2,[6,"cms_sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/comments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/countries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_country_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"countries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/countries/:country_id/states/:id/edit(.:format)
 * @param {any} country_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_country_state_path = /*#__PURE__*/ __jsr.r({"country_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"countries"],[2,[7,"/"],[2,[3,"country_id"],[2,[7,"/"],[2,[6,"states"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/dashboard/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/data_feeds/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_data_feed_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"data_feeds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/desktop_top_banners/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_desktop_top_banner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"desktop_top_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/editable_pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_editable_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"editable_pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/editable_pages/:editable_page_id/editable_page_images/:id/edit(.:format)
 * @param {any} editable_page_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_editable_page_editable_page_image_path = /*#__PURE__*/ __jsr.r({"editable_page_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"editable_pages"],[2,[7,"/"],[2,[3,"editable_page_id"],[2,[7,"/"],[2,[6,"editable_page_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/free_samples/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_free_sample_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"free_samples"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/gift_cards/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_gift_card_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"gift_cards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/homepage_innovators/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_homepage_innovator_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"homepage_innovators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/ingredients/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_ingredient_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ingredients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/innovator_highlights/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_innovator_highlight_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"innovator_highlights"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/double_points_products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_loyalty_program_double_points_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"double_points_products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/point_actions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_loyalty_program_point_action_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"point_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/redeem_point_actions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_loyalty_program_redeem_point_action_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"redeem_point_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/tiers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_loyalty_program_tier_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"tiers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/menus/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_menu_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/menus/:menu_id/menu_items/:id/edit(.:format)
 * @param {any} menu_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_menu_menu_item_path = /*#__PURE__*/ __jsr.r({"menu_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"menu_id"],[2,[7,"/"],[2,[6,"menu_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/mobile_top_banners/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_mobile_top_banner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mobile_top_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/oauth_applications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_oauth_application_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth_applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/option_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_option_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/option_types/:option_type_id/option_values/:id/edit(.:format)
 * @param {any} option_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_option_type_option_value_path = /*#__PURE__*/ __jsr.r({"option_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[3,"option_type_id"],[2,[7,"/"],[2,[6,"option_values"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/adjustments/:id/edit(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_order_adjustment_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/customer/edit(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_order_customer_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"customer"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/customer_returns/:id/edit(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_order_customer_return_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"customer_returns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/payments/:id/edit(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_order_payment_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/payments/:payment_id/log_entries/:id/edit(.:format)
 * @param {any} order_id
 * @param {any} payment_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_order_payment_log_entry_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"payment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"payment_id"],[2,[7,"/"],[2,[6,"log_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/payments/:payment_id/refunds/:id/edit(.:format)
 * @param {any} order_id
 * @param {any} payment_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_order_payment_refund_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"payment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"payment_id"],[2,[7,"/"],[2,[6,"refunds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/reimbursements/:id/edit(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_order_reimbursement_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"reimbursements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/return_authorizations/:id/edit(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_order_return_authorization_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/payment_methods/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_payment_method_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/press_banners/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_press_banner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"press_banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/print_invoice_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_print_invoice_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"print_invoice_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/images/:id/edit(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_product_image_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/product_properties/:id/edit(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_product_product_property_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"product_properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/relations/:id/edit(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_product_relation_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"relations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/variants/:id/edit(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_product_variant_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_promotion_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotion_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_promotion_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotion_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotions/:promotion_id/promotion_actions/:id/edit(.:format)
 * @param {any} promotion_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_promotion_promotion_action_path = /*#__PURE__*/ __jsr.r({"promotion_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[3,"promotion_id"],[2,[7,"/"],[2,[6,"promotion_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotions/:promotion_id/promotion_rules/:id/edit(.:format)
 * @param {any} promotion_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_promotion_promotion_rule_path = /*#__PURE__*/ __jsr.r({"promotion_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[3,"promotion_id"],[2,[7,"/"],[2,[6,"promotion_rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/properties/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/prototypes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_prototype_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"prototypes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/quad_pay_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_quad_pay_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"quad_pay_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/questions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_question_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/refund_reasons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_refund_reason_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"refund_reasons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reimbursement_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_reimbursement_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reimbursement_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/relation_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_relation_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"relation_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/return_authorization_reasons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_return_authorization_reason_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"return_authorization_reasons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reviews/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_review_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reviews/:review_id/reply/edit(.:format)
 * @param {any} review_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_review_reply_path = /*#__PURE__*/ __jsr.r({"review_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"review_id"],[2,[7,"/"],[2,[6,"reply"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/roles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_role_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/searchable_pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_searchable_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"searchable_pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/shipping_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_shipping_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"shipping_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/shipping_methods/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_shipping_method_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"shipping_methods"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/shops/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_shop_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"shops"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/states/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_state_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"states"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stock_locations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_stock_location_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stores/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_store_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stores"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/store_credit_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_store_credit_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"store_credit_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/subscriptions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/tax_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_tax_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tax_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/tax_rates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_tax_rate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tax_rates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxjar_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_taxjar_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxjar_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxonomies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_taxonomy_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxonomies/:taxonomy_id/taxons/:id/edit(.:format)
 * @param {any} taxonomy_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_taxonomy_taxon_path = /*#__PURE__*/ __jsr.r({"taxonomy_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"taxonomy_id"],[2,[7,"/"],[2,[6,"taxons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/users/:user_id/store_credits/:id/edit(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_user_store_credit_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"store_credits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/vanity_urls/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_vanity_url_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vanity_urls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/webhooks_subscribers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_webhooks_subscriber_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"webhooks_subscribers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/zones/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_admin_zone_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/products/:product_id/relations/:id/edit(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_product_relation_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"relations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/line_items/:id/edit(.:format)
 * @param {any} checkout_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_checkout_line_item_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"line_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/payments/:id/edit(.:format)
 * @param {any} checkout_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_checkout_payment_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/return_authorizations/:id/edit(.:format)
 * @param {any} checkout_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_checkout_return_authorization_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/option_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_option_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/option_types/:option_type_id/option_values/:id/edit(.:format)
 * @param {any} option_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_option_type_option_value_path = /*#__PURE__*/ __jsr.r({"option_type_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[3,"option_type_id"],[2,[7,"/"],[2,[6,"option_values"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/option_values/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_option_value_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"option_values"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/line_items/:id/edit(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_order_line_item_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"line_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/payments/:id/edit(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_order_payment_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/return_authorizations/:id/edit(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_order_return_authorization_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/products/:product_id/images/:id/edit(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_product_image_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/products/:product_id/product_properties/:id/edit(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_product_product_property_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"product_properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/products/:product_id/variants/:id/edit(.:format)
 * @param {any} product_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_product_variant_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/properties/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stock_locations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_stock_location_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stock_locations/:stock_location_id/stock_items/:id/edit(.:format)
 * @param {any} stock_location_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_stock_location_stock_item_path = /*#__PURE__*/ __jsr.r({"stock_location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"stock_location_id"],[2,[7,"/"],[2,[6,"stock_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stock_locations/:stock_location_id/stock_movements/:id/edit(.:format)
 * @param {any} stock_location_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_stock_location_stock_movement_path = /*#__PURE__*/ __jsr.r({"stock_location_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"stock_location_id"],[2,[7,"/"],[2,[6,"stock_movements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stores/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_store_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stores"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/taxonomies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_taxonomy_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/taxonomies/:taxonomy_id/taxons/:id/edit(.:format)
 * @param {any} taxonomy_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_taxonomy_taxon_path = /*#__PURE__*/ __jsr.r({"taxonomy_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"taxonomy_id"],[2,[7,"/"],[2,[6,"taxons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/variants/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_variant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/variants/:variant_id/images/:id/edit(.:format)
 * @param {any} variant_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_variant_image_path = /*#__PURE__*/ __jsr.r({"variant_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"variant_id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/zones/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v1_zone_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/addresses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_address_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/adjustments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_adjustment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/classifications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_classification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"classifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/cms_pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_cms_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"cms_pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/cms_sections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_cms_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"cms_sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/credit_cards/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_credit_card_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"credit_cards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/customer_returns/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_customer_return_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"customer_returns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/data_feeds/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_data_feed_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"data_feeds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/digitals/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_digital_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"digitals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/digital_links/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_digital_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"digital_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/images/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/inventory_units/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_inventory_unit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"inventory_units"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/line_items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_line_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"line_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/menus/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_menu_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/menu_items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_menu_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"menu_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/option_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_option_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/option_values/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_option_value_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"option_values"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/orders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/payments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_payment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/payment_methods/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_payment_method_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/product_properties/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_product_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"product_properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/promotions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_promotion_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/promotion_actions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_promotion_action_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"promotion_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/promotion_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_promotion_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"promotion_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/promotion_rules/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_promotion_rule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"promotion_rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/properties/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/reimbursements/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_reimbursement_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"reimbursements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/return_authorizations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_return_authorization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/roles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_role_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipping_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_shipping_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipping_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipping_methods/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_shipping_method_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipping_methods"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/stock_items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_stock_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"stock_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/stock_locations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_stock_location_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/stock_movements/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_stock_movement_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"stock_movements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/stores/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_store_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"stores"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/store_credits/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_store_credit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"store_credits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/store_credit_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_store_credit_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"store_credit_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/store_credit_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_store_credit_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"store_credit_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/tax_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_tax_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"tax_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/tax_rates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_tax_rate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"tax_rates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/taxons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_taxon_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"taxons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/taxonomies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_taxonomy_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/variants/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_variant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/webhooks/subscribers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_webhooks_subscriber_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/wished_items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_wished_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"wished_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/wishlists/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_wishlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/zones/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_platform_zone_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/account/addresses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_storefront_account_address_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/wishlists/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_api_v2_storefront_wishlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/orders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_edit_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:id/empty(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_empty_api_v1_checkout_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"empty"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:id/empty(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_empty_api_v1_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"empty"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/orders/:id/empty(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_empty_api_v2_platform_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"empty"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/cart/empty(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_empty_api_v2_storefront_cart_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"empty"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/cart/estimate_shipping_rates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_estimate_shipping_rates_api_v2_storefront_cart_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"estimate_shipping_rates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/properties/filtered(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_filtered_admin_properties_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[6,"filtered"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/payments/:id/fire(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_fire_admin_order_payment_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"fire"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/free_samples/add(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_free_samples_add_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"free_samples"],[2,[7,"/"],[2,[6,"add"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/free_samples/remove(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_free_samples_remove_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"free_samples"],[2,[7,"/"],[2,[6,"remove"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/gift_cards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_gift_cards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"gift_cards"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/gift_cards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_gift_cards_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"gift_cards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/gift_cards/redeem(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_gift_cards_redeem_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"gift_cards"],[2,[7,"/"],[2,[6,"redeem"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/gift_cards_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_gift_cards_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"gift_cards_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/innovator_commission(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_innovator_commission_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"innovator_commission"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/innovator_commission_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_innovator_commission_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"innovator_commission_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/users/:id/items(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_items_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/taxonomies/:id/jstree(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_jstree_api_v1_taxonomy_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"jstree"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/taxonomies/:taxonomy_id/taxons/:id/jstree(.:format)
 * @param {any} taxonomy_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_jstree_api_v1_taxonomy_taxon_path = /*#__PURE__*/ __jsr.r({"taxonomy_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"taxonomy_id"],[2,[7,"/"],[2,[6,"taxons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"jstree"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/lineitems_for_taxjar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_lineitems_for_taxjar_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"lineitems_for_taxjar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/lineitems_for_taxjar_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_lineitems_for_taxjar_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"lineitems_for_taxjar_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/ltv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_ltv_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"ltv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/ltv_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_ltv_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"ltv_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/shipments/mine(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_mine_api_v1_shipments_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[6,"mine"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/money_cohort(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_money_cohort_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"money_cohort"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/money_cohort_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_money_cohort_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"money_cohort_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/monthly_inventory_sold(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_monthly_inventory_sold_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly_inventory_sold"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/monthly_inventory_sold_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_monthly_inventory_sold_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly_inventory_sold_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/monthly_sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_monthly_sales_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly_sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/monthly_sales_completion_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_monthly_sales_completion_date_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly_sales_completion_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/monthly_sales_completion_date_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_monthly_sales_completion_date_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly_sales_completion_date_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/monthly_sales_payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_monthly_sales_payments_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly_sales_payments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/monthly_sales_payments_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_monthly_sales_payments_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly_sales_payments_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/monthly_sales_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_monthly_sales_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly_sales_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/t/*id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_nested_taxons_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"t"],[2,[7,"/"],[2,[5,[3,"id"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/articles/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_article_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/banners/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_banner_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blacklisted_addresses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_blacklisted_address_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blacklisted_addresses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blacklisted_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_blacklisted_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blacklisted_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blog/categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_blog_category_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blog/posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_blog_post_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/campaigns/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_campaign_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/campaigns/:campaign_id/variants/new(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_campaign_variant_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_category_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/cms/pages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_cms_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cms"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/cms/pages/:page_id/blocks/new(.:format)
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_cms_page_block_path = /*#__PURE__*/ __jsr.r({"page_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cms"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/cms_pages/:cms_page_id/cms_sections/new(.:format)
 * @param {any} cms_page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_cms_page_cms_section_path = /*#__PURE__*/ __jsr.r({"cms_page_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cms_pages"],[2,[7,"/"],[2,[3,"cms_page_id"],[2,[7,"/"],[2,[6,"cms_sections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/comments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_comment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/countries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_country_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"countries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/countries/:country_id/states/new(.:format)
 * @param {any} country_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_country_state_path = /*#__PURE__*/ __jsr.r({"country_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"countries"],[2,[7,"/"],[2,[3,"country_id"],[2,[7,"/"],[2,[6,"states"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/dashboard/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/data_feeds/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_data_feed_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"data_feeds"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/desktop_top_banners/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_desktop_top_banner_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"desktop_top_banners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/editable_pages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_editable_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"editable_pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/editable_pages/:editable_page_id/editable_page_images/new(.:format)
 * @param {any} editable_page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_editable_page_editable_page_image_path = /*#__PURE__*/ __jsr.r({"editable_page_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"editable_pages"],[2,[7,"/"],[2,[3,"editable_page_id"],[2,[7,"/"],[2,[6,"editable_page_images"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/free_samples/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_free_sample_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"free_samples"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/gift_cards/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_gift_card_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"gift_cards"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/homepage_innovators/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_homepage_innovator_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"homepage_innovators"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/ingredients/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_ingredient_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ingredients"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/innovator_highlights/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_innovator_highlight_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"innovator_highlights"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/double_points_products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_loyalty_program_double_points_product_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"double_points_products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/point_actions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_loyalty_program_point_action_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"point_actions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/redeem_point_actions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_loyalty_program_redeem_point_action_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"redeem_point_actions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/tiers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_loyalty_program_tier_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"tiers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/menus/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_menu_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/menus/:menu_id/menu_items/new(.:format)
 * @param {any} menu_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_menu_menu_item_path = /*#__PURE__*/ __jsr.r({"menu_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"menu_id"],[2,[7,"/"],[2,[6,"menu_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/mobile_top_banners/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_mobile_top_banner_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mobile_top_banners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/oauth_applications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_oauth_application_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth_applications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/option_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_option_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/option_types/:option_type_id/option_values/new(.:format)
 * @param {any} option_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_option_type_option_value_path = /*#__PURE__*/ __jsr.r({"option_type_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[3,"option_type_id"],[2,[7,"/"],[2,[6,"option_values"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_order_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/adjustments/new(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_order_adjustment_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/customer/new(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_order_customer_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"customer"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/customer_returns/new(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_order_customer_return_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"customer_returns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/payments/new(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_order_payment_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/payments/:payment_id/log_entries/new(.:format)
 * @param {any} order_id
 * @param {any} payment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_order_payment_log_entry_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"payment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"payment_id"],[2,[7,"/"],[2,[6,"log_entries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/payments/:payment_id/refunds/new(.:format)
 * @param {any} order_id
 * @param {any} payment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_order_payment_refund_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"payment_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"payment_id"],[2,[7,"/"],[2,[6,"refunds"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/return_authorizations/new(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_order_return_authorization_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/payment_methods/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_payment_method_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/press_banners/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_press_banner_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"press_banners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_product_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/images/new(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_product_image_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/product_properties/new(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_product_product_property_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"product_properties"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/relations/new(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_product_relation_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"relations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/variants/new(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_product_variant_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_promotion_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotion_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_promotion_category_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotion_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotions/:promotion_id/promotion_actions/new(.:format)
 * @param {any} promotion_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_promotion_promotion_action_path = /*#__PURE__*/ __jsr.r({"promotion_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[3,"promotion_id"],[2,[7,"/"],[2,[6,"promotion_actions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/promotions/:promotion_id/promotion_rules/new(.:format)
 * @param {any} promotion_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_promotion_promotion_rule_path = /*#__PURE__*/ __jsr.r({"promotion_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[3,"promotion_id"],[2,[7,"/"],[2,[6,"promotion_rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/properties/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_property_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/prototypes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_prototype_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"prototypes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/questions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_question_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/refund_reasons/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_refund_reason_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"refund_reasons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reimbursement_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_reimbursement_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reimbursement_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/relation_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_relation_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"relation_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/return_authorization_reasons/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_return_authorization_reason_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"return_authorization_reasons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reviews/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_review_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/roles/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_role_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/searchable_pages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_searchable_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"searchable_pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/shipping_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_shipping_category_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"shipping_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/shipping_methods/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_shipping_method_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"shipping_methods"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/shops/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_shop_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"shops"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/states/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_state_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"states"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stock_locations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_stock_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stock_locations/:stock_location_id/stock_movements/new(.:format)
 * @param {any} stock_location_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_stock_location_stock_movement_path = /*#__PURE__*/ __jsr.r({"stock_location_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"stock_location_id"],[2,[7,"/"],[2,[6,"stock_movements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stock_transfers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_stock_transfer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stock_transfers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stores/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_store_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stores"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/store_credit_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_store_credit_category_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"store_credit_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/tax_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_tax_category_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tax_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/tax_rates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_tax_rate_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tax_rates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxjar_settings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_taxjar_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxjar_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxonomies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_taxonomy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxonomies/:taxonomy_id/taxons/new(.:format)
 * @param {any} taxonomy_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_taxonomy_taxon_path = /*#__PURE__*/ __jsr.r({"taxonomy_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"taxonomy_id"],[2,[7,"/"],[2,[6,"taxons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/users/:user_id/store_credits/new(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_user_store_credit_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"store_credits"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/vanity_urls/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_vanity_url_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vanity_urls"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/webhooks_subscribers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_webhooks_subscriber_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"webhooks_subscribers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/zones/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_admin_zone_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/products/:product_id/relations/new(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_product_relation_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"relations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/line_items/new(.:format)
 * @param {any} checkout_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_checkout_line_item_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"line_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/payments/new(.:format)
 * @param {any} checkout_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_checkout_payment_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/return_authorizations/new(.:format)
 * @param {any} checkout_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_checkout_return_authorization_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/option_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_option_type_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/option_types/:option_type_id/option_values/new(.:format)
 * @param {any} option_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_option_type_option_value_path = /*#__PURE__*/ __jsr.r({"option_type_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[3,"option_type_id"],[2,[7,"/"],[2,[6,"option_values"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/option_values/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_option_value_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"option_values"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_order_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/line_items/new(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_order_line_item_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"line_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/payments/new(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_order_payment_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/return_authorizations/new(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_order_return_authorization_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_product_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/products/:product_id/images/new(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_product_image_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/products/:product_id/product_properties/new(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_product_product_property_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"product_properties"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/products/:product_id/variants/new(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_product_variant_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/properties/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_property_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stock_locations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_stock_location_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stock_locations/:stock_location_id/stock_items/new(.:format)
 * @param {any} stock_location_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_stock_location_stock_item_path = /*#__PURE__*/ __jsr.r({"stock_location_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"stock_location_id"],[2,[7,"/"],[2,[6,"stock_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stock_locations/:stock_location_id/stock_movements/new(.:format)
 * @param {any} stock_location_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_stock_location_stock_movement_path = /*#__PURE__*/ __jsr.r({"stock_location_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[3,"stock_location_id"],[2,[7,"/"],[2,[6,"stock_movements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/stores/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_store_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stores"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/taxonomies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_taxonomy_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/taxonomies/:taxonomy_id/taxons/new(.:format)
 * @param {any} taxonomy_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_taxonomy_taxon_path = /*#__PURE__*/ __jsr.r({"taxonomy_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"taxonomy_id"],[2,[7,"/"],[2,[6,"taxons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_user_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/variants/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_variant_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/variants/:variant_id/images/new(.:format)
 * @param {any} variant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_variant_image_path = /*#__PURE__*/ __jsr.r({"variant_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"variant_id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/zones/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v1_zone_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/addresses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_address_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/adjustments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_adjustment_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"adjustments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/classifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_classification_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"classifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/cms_pages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_cms_page_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"cms_pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/cms_sections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_cms_section_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"cms_sections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/credit_cards/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_credit_card_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"credit_cards"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/customer_returns/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_customer_return_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"customer_returns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/data_feeds/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_data_feed_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"data_feeds"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/digitals/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_digital_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"digitals"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/digital_links/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_digital_link_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"digital_links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/images/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_image_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/inventory_units/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_inventory_unit_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"inventory_units"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/line_items/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_line_item_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"line_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/menus/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_menu_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/menu_items/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_menu_item_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"menu_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/option_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_option_type_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/option_values/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_option_value_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"option_values"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/orders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_order_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/payments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_payment_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/payment_methods/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_payment_method_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_product_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/product_properties/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_product_property_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"product_properties"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/promotions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_promotion_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/promotion_actions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_promotion_action_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"promotion_actions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/promotion_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_promotion_category_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"promotion_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/promotion_rules/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_promotion_rule_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"promotion_rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/properties/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_property_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/reimbursements/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_reimbursement_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"reimbursements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/return_authorizations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_return_authorization_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/roles/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_role_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_shipment_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipping_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_shipping_category_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipping_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipping_methods/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_shipping_method_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipping_methods"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/stock_items/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_stock_item_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"stock_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/stock_locations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_stock_location_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/stock_movements/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_stock_movement_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"stock_movements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/stores/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_store_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"stores"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/store_credits/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_store_credit_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"store_credits"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/store_credit_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_store_credit_category_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"store_credit_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/store_credit_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_store_credit_type_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"store_credit_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/tax_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_tax_category_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"tax_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/tax_rates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_tax_rate_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"tax_rates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/taxons/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_taxon_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"taxons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/taxonomies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_taxonomy_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_user_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/variants/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_variant_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/webhooks/subscribers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_webhooks_subscriber_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/wished_items/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_wished_item_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"wished_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/wishlists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_wishlist_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/zones/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_platform_zone_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/account/addresses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_storefront_account_address_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/wishlists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_api_v2_storefront_wishlist_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/products/*id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_nested_taxons_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"products"],[2,[7,"/"],[2,[5,[3,"id"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_new_product_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:id/next(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_next_api_v1_checkout_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"next"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/orders/:id/next(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_next_api_v2_platform_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"next"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/checkout/next(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_next_api_v2_storefront_checkout_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"next"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/paypal/notify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_notify_paypal_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"notify"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:id/open_adjustments(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_open_adjustments_admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"open_adjustments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/order_totals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_order_totals_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"order_totals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/order_totals_completion_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_order_totals_completion_date_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"order_totals_completion_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/order_totals_completion_date_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_order_totals_completion_date_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"order_totals_completion_date_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/order_totals_per_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_order_totals_per_state_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"order_totals_per_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/order_totals_per_state_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_order_totals_per_state_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"order_totals_per_state_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/order_totals_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_order_totals_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"order_totals_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/users/:id/orders(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_orders_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/orders_cohort(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_orders_cohort_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"orders_cohort"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/orders_cohort_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_orders_cohort_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"orders_cohort_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/orders_for_taxjar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_orders_for_taxjar_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"orders_for_taxjar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/orders_for_taxjar_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_orders_for_taxjar_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"orders_for_taxjar_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/checkout/payment_methods(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_payment_methods_api_v2_storefront_checkout_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"payment_methods"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/paypal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_paypal_express_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"paypal"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/payments/:id/paypal_refund(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_paypal_refund_admin_order_payment_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"paypal_refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipments/:id/pend(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_pend_api_v2_platform_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/reimbursements/:id/perform(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_perform_admin_order_reimbursement_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"reimbursements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"perform"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/orders/populate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_populate_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"orders"],[2,[7,"/"],[2,[6,"populate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/preorder_totals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_preorder_totals_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"preorder_totals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/preorder_totals_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_preorder_totals_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"preorder_totals_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/products/:product_id/cross_sells(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_product_cross_sells_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"cross_sells"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/products/:product_id/reviews(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_product_reviews_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/products/:product_id/variants(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_product_variants_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /shop/products_by_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_products_by_ids_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"products_by_ids"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/promotions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_promotions_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"promotions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/promotions_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_promotions_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"promotions_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/payments/:id/purchase(.:format)
 * @param {any} checkout_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_purchase_api_v1_checkout_payment_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"purchase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/payments/:id/purchase(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_purchase_api_v1_order_payment_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"purchase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/purchasers_emails_by_sku(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_purchasers_emails_by_sku_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"purchasers_emails_by_sku"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/purchasers_emails_by_sku_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_purchasers_emails_by_sku_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"purchasers_emails_by_sku_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/orders/quadpay_cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_quadpay_cancel_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"orders"],[2,[7,"/"],[2,[6,"quadpay_cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/orders/quadpay_confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_quadpay_confirm_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"orders"],[2,[7,"/"],[2,[6,"quadpay_confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/shipments/:id/ready(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_ready_api_v1_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ready"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipments/:id/ready(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_ready_api_v2_platform_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ready"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/return_authorizations/:id/receive(.:format)
 * @param {any} checkout_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_receive_api_v1_checkout_return_authorization_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"receive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/return_authorizations/:id/receive(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_receive_api_v1_order_return_authorization_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"receive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/return_authorizations/:id/receive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_receive_api_v2_platform_return_authorization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"return_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"receive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/bookkeeping_documents/refresh(.:format)
 * @param {any} order_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_refresh_admin_order_bookkeeping_documents_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"bookkeeping_documents"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:order_id/customer_returns/:id/refund(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_refund_admin_order_customer_return_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"customer_returns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/regimen_finder_results(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_regimen_finder_results_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"regimen_finder_results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/regimen_finder_results_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_regimen_finder_results_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"regimen_finder_results_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:id/related(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_related_admin_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"related"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/products/:id/related(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_related_api_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"related"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/shipments/:id/remove(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_remove_api_v1_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:id/remove_coupon_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_remove_coupon_code_api_v1_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_coupon_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/menus/:menu_id/menu_items/:id/remove_icon(.:format)
 * @param {any} menu_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_remove_icon_admin_menu_menu_item_path = /*#__PURE__*/ __jsr.r({"menu_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"menus"],[2,[7,"/"],[2,[3,"menu_id"],[2,[7,"/"],[2,[6,"menu_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_icon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxonomies/:taxonomy_id/taxons/:id/remove_icon(.:format)
 * @param {any} taxonomy_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_remove_icon_admin_taxonomy_taxon_path = /*#__PURE__*/ __jsr.r({"taxonomy_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"taxonomy_id"],[2,[7,"/"],[2,[6,"taxons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_icon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipments/:id/remove_item(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_remove_item_api_v2_platform_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/wishlists/:id/remove_item/:item_id(.:format)
 * @param {any} id
 * @param {any} item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_remove_item_api_v2_storefront_wishlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"item_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_item"],[2,[7,"/"],[2,[3,"item_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/wishlists/:id/remove_items(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_remove_items_api_v2_storefront_wishlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/checkout/remove_store_credit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_remove_store_credit_api_v2_storefront_checkout_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"remove_store_credit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/repeat_customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_repeat_customers_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"repeat_customers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/repeat_customers_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_repeat_customers_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"repeat_customers_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/menu_items/:id/reposition(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_reposition_api_v2_platform_menu_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"menu_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reposition"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/taxons/:id/reposition(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_reposition_api_v2_platform_taxon_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"taxons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reposition"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:id/resend(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_resend_admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipments/:id/resend(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_resend_api_v2_platform_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/digital_links/:id/reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_reset_api_v2_platform_digital_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"digital_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:id/reset_digitals(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_reset_digitals_admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_digitals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:id/resume(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_resume_admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipments/:id/resume(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_resume_api_v2_platform_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/returns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_returns_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"returns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/returns_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_returns_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"returns_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/revenue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_revenue_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"revenue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/revenue_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_revenue_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"revenue_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_root_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"shop"]],[7,"/"]]);

/**
 * Generates rails route to
 * /shop/admin/reports/sales_by_source(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_sales_by_source_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"sales_by_source"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/sales_total(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_sales_total_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"sales_total"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/prototypes/:id/select(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_select_admin_prototype_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"prototypes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"select"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/checkout/select_shipping_method(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_select_shipping_method_api_v2_storefront_checkout_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"select_shipping_method"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/orders/:id/set_channel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_set_channel_admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/wishlists/:id/set_item_quantity/:item_id(.:format)
 * @param {any} id
 * @param {any} item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_set_item_quantity_api_v2_storefront_wishlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"item_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_item_quantity"],[2,[7,"/"],[2,[3,"item_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/cart/set_quantity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_set_quantity_api_v2_storefront_cart_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"set_quantity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/shipments/:id/ship(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_ship_api_v1_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ship"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipments/:id/ship(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_ship_api_v2_platform_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ship"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/shipment_totals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_shipment_totals_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"shipment_totals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/shipment_totals_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_shipment_totals_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"shipment_totals_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/storefront/checkout/shipping_rates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_shipping_rates_api_v2_storefront_checkout_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"storefront"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"shipping_rates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/shipworks/api(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_shipworks_api_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"shipworks"],[2,[7,"/"],[2,[6,"api"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shop/checkout_now(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_single_page_checkout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"checkout_now"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:id/stock(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_stock_admin_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"stock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/subscription_order_totals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_subscription_order_totals_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"subscription_order_totals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/subscription_order_totals_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_subscription_order_totals_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"subscription_order_totals_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/suspicious_votes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_suspicious_votes_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"suspicious_votes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/suspicious_votes_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_suspicious_votes_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"suspicious_votes_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/t/categories/all-products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_t_categories_all_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"t"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"all-products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/taxons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_taxons_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"taxons"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /shop/admin/comments/:id/top_comment(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_top_comment_admin_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"top_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stock_locations/transfer_stock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_transfer_stock_admin_stock_locations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stock_locations"],[2,[7,"/"],[2,[6,"transfer_stock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/shipments/transfer_to_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_transfer_to_location_api_v1_shipments_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[6,"transfer_to_location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipments/:id/transfer_to_location(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_transfer_to_location_api_v2_platform_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"transfer_to_location"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/shipments/transfer_to_shipment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_transfer_to_shipment_api_v1_shipments_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[6,"transfer_to_shipment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/shipments/:id/transfer_to_shipment(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_transfer_to_shipment_api_v2_platform_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"transfer_to_shipment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/option_types/:id/translations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_translations_admin_option_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"translations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/option_types/:option_type_id/option_values/:id/translations(.:format)
 * @param {any} option_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_translations_admin_option_type_option_value_path = /*#__PURE__*/ __jsr.r({"option_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[3,"option_type_id"],[2,[7,"/"],[2,[6,"option_values"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"translations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:id/translations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_translations_admin_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"translations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/stores/:id/translations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_translations_admin_store_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stores"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"translations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxonomies/:id/translations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_translations_admin_taxonomy_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"translations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxonomies/:taxonomy_id/taxons/:id/translations(.:format)
 * @param {any} taxonomy_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_translations_admin_taxonomy_taxon_path = /*#__PURE__*/ __jsr.r({"taxonomy_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[3,"taxonomy_id"],[2,[7,"/"],[2,[6,"taxons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"translations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/units_purchased(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_units_purchased_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"units_purchased"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/units_purchased_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_units_purchased_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"units_purchased_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/cart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_cart_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"cart"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /shop/admin/suspicious_votes/update_multiple(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_multiple_admin_suspicious_votes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"suspicious_votes"],[2,[7,"/"],[2,[6,"update_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/banners/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_banners_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banners"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/blog/categories/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_blog_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/campaigns/:campaign_id/variants/update_positions(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_campaign_variants_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/categories/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/cms/pages/:page_id/blocks/update_positions(.:format)
 * @param {any} page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_cms_page_blocks_path = /*#__PURE__*/ __jsr.r({"page_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cms"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"page_id"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/desktop_top_banners/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_desktop_top_banners_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"desktop_top_banners"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/editable_pages/:editable_page_id/editable_page_images/update_positions(.:format)
 * @param {any} editable_page_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_editable_page_editable_page_images_path = /*#__PURE__*/ __jsr.r({"editable_page_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"editable_pages"],[2,[7,"/"],[2,[3,"editable_page_id"],[2,[7,"/"],[2,[6,"editable_page_images"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/free_samples/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_free_samples_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"free_samples"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/homepage_innovators/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_homepage_innovators_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"homepage_innovators"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/innovator_highlights/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_innovator_highlights_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"innovator_highlights"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/point_actions/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_loyalty_program_point_actions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"point_actions"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/loyalty_program/redeem_point_actions/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_loyalty_program_redeem_point_actions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loyalty_program"],[2,[7,"/"],[2,[6,"redeem_point_actions"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/mobile_top_banners/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_mobile_top_banners_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mobile_top_banners"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/option_types/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_option_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/payment_methods/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_payment_methods_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_methods"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/press_banners/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_press_banners_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"press_banners"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/images/update_positions(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_product_images_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/product_properties/update_positions(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_product_product_properties_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"product_properties"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/relations/update_positions(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_product_relations_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"relations"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/products/:product_id/variants/update_positions(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_product_variants_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/taxonomies/update_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_admin_taxonomies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxonomies"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/products/:product_id/relations/update_positions(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_positions_api_product_relations_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"relations"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/option_types/update_values_positions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_update_values_positions_admin_option_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"option_types"],[2,[7,"/"],[2,[6,"update_values_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v2/platform/orders/:id/use_store_credit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_use_store_credit_api_v2_platform_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"use_store_credit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/user_analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_user_analytics_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"user_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/user_analytics_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_user_analytics_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"user_analytics_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/checkouts/:checkout_id/payments/:id/void(.:format)
 * @param {any} checkout_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_void_api_v1_checkout_payment_path = /*#__PURE__*/ __jsr.r({"checkout_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[3,"checkout_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"void"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/api/v1/orders/:order_id/payments/:id/void(.:format)
 * @param {any} order_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_void_api_v1_order_payment_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"void"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/vote_conversion(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_vote_conversion_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"vote_conversion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/vote_conversion_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_vote_conversion_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"vote_conversion_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/voters_for_campaign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_voters_for_campaign_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"voters_for_campaign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/voters_for_campaign_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_voters_for_campaign_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"voters_for_campaign_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/waitlist_by_product(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_waitlist_by_product_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"waitlist_by_product"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/admin/reports/waitlist_by_product_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spree_waitlist_by_product_report_admin_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"shop"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"waitlist_by_product_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_admin_ideas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stores(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stores_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stores"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscriber(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriber_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriber"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/sign_up/success(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/:id/update_password(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_password_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/subscriptions/:id/update_payment_source(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_payment_source_user_subscription_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_payment_source"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /phrasing/upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_phrasing_phrases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"phrasing"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/upvote(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upvote_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upvote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_confirmation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/credit_cards/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_credit_card_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"credit_cards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/facebook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_facebook_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"facebook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/facebook/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_facebook_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/google_oauth2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_google_oauth2_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/google_oauth2/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_google_oauth2_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/ideas/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_idea_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/ideas/:idea_id/send_email(.:format)
 * @param {any} user_id
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_idea_send_email_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/ideas/:idea_id/submit_additional_fields(.:format)
 * @param {any} user_id
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_idea_submit_additional_fields_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"submit_additional_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/ideas/:idea_id/submit_address(.:format)
 * @param {any} user_id
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_idea_submit_address_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[2,[7,"/"],[2,[6,"submit_address"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/ideas(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_ideas_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"ideas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notifications/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notifications(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notifications_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/orders(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_orders_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/rewards(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_rewards_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"rewards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/store_credit(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_store_credit_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"store_credit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/subscriptions/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_subscription_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/subscriptions(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_subscriptions_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/votes(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_votes_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"votes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /visitors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visitors_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"visitors"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /vote(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vote_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vote"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /voter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const voter_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"voter"],[1,[2,[8,"."],[3,"format"]]]]]);


